<template>
  <choice-layout
    :options-number="options.length"
    :option-search-query="optionSearchQuery"
    :is-showing-all-options="isShowingAllOptions"
    :is-showing-load-more-button="isShowingLoadMoreButton"
    @load-more-options="onLoadMoreOptions"
  >
    <inline-option
      v-for="(option, index) in visibleOptions"
      :key="index"
      :option="option"
      :is-selected="isSelected(option)"
      is-multiple
      :is-disabled="isDisabled(option)"
      :variant="inlineOptionVariant"
      @select="onSelect"
    />
  </choice-layout>
</template>

<script>
// @flow

import { searchInOptions } from '../../../../utils/optionUtils'

import InlineOption from '../InlineOption/InlineOption.vue'
import ChoiceLayout from '../ChoiceLayout/ChoiceLayout.vue'
import { shouldEnableMoreOptions } from '../../../../../common/layout'

export default {
  components: {
    InlineOption,
    ChoiceLayout
  },
  props: {
    question: {
      type: Object, // WizardPage
      required: true
    },
    questionData: {
      type: Object, // WizardPageData<MultipleChoiceData>
      required: true
    },
    selected: {
      type: Array,
      default: () => ([])
    },
    optionSearchQuery: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isShowingAllOptions: false
    }
  },
  computed: {
    inlineOptionVariant () {
      return shouldEnableMoreOptions(this.questionData.options.length) ? 'multiline' : 'inline'
    },
    options (): Array<Object> {
      if (this.optionSearchQuery) return searchInOptions(this.optionSearchQuery, this.questionData.options)
      return this.questionData.options ?? []
    },
    visibleOptions (): Array<Object> {
      if (this.isShowingAllOptions || !this.isShowingLoadMoreButton) return this.options
      return this.options.slice(0, this.threshold)
    },
    isShowingLoadMoreButton (): number {
      return this.options.length > 18
    },
    threshold (): number {
      return 15
    }
  },
  methods: {
    onSelect (option) {
      const { question } = this
      this.$emit('select', { question, option })
    },
    isSelected (option) {
      return this.selected.includes(option.uuid)
    },
    isDisabled (option) {
      if (!this.questionData.maxSelectableOptions) return false
      if (this.selected.includes(option.uuid)) return false

      return this.selected.length === this.questionData.maxSelectableOptions
    },
    onLoadMoreOptions (): void {
      this.isShowingAllOptions = true
    }
  }
}
</script>
